import type { LocationSummary, Me } from "../../api/contracts";

export interface Pulse { lastPlannedAt: string | null; lastEventAt: string | null; nextNightlyRunAt: string | null }

const latest = (values: (string | null)[]): string | null =>
  values.reduce<string | null>((best, v) => (v !== null && (best === null || Date.parse(v) > Date.parse(best)) ? v : best), null);

/** The rail's three facts, from the locations the viewer can see plus `me`. Missing data is null, never a guess. */
export function derivePulse(locations: LocationSummary[] | undefined, me: Me | null | undefined): Pulse {
  return {
    lastPlannedAt: latest((locations ?? []).map((l) => l.lastPlannedAt)),
    lastEventAt: latest((locations ?? []).map((l) => l.lastEventAt)),
    nextNightlyRunAt: me?.nextNightlyRunAt ?? null,
  };
}
